import React from "react";
import { EmptySitesSvg } from "assets/icons/EmptySitesSvg";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { NO_SITES_FOUND } from "configurations/MessageConstants";

const EmptySites = () => {
  const navigate = useNavigate();
  return (
    <div className="text-center d-flex flex-column align-items-center my-2">
      <EmptySitesSvg />
      <small>{NO_SITES_FOUND}</small>
      <Button
        variant="outline-dark"
        size="sm"
        className="rounded-pill my-2"
        onClick={() => navigate("/site-registration")}
      >
        <i className="fa fa-circle-plus me-1"></i>
        Register Site
      </Button>
    </div>
  );
};

export default EmptySites;
